import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import vuecookie from 'vue-cookies'

const state = {
    logEntries: [],
    logTypes: []
};

const getters = {
    getLogEntries: (state) => state.logEntries,
    getLogTypes: (state) => state.logTypes
};

const actions = {
    async getLogEntries( context, data ) {
        await axios.get(`${backendUrl()}/getLogEntries`,
        {
            params: { 
                page: data.page, 
                per_page: data.per_page,
                log_type: data.log_type,
                date_from : data.date_from,
                date_to : data.date_to,
                ip : data.ip,
                email: data.email,
                account: data.account,
                user: data.user,
                customer: data.customer
            },
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setLogEntries', response.data)
        })
    },
    async getLogTypes( context ) {
        await axios.post(`${backendUrl()}/getLogTypes`,
        {
            token:context.getters.allTemplateDetails.token
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setLogTypes', response.data)
        })
    },

    exportLogsToCSV( context, data ) {
        axios.post(`${backendUrl()}/exportLogsToCSV`, {
            userId: context.getters.getUserDetails.id,
            userLevel: context.getters.getUserLevel,
            filters: data
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then( response => {
            context.dispatch('handleResponse', response)
        })
    }
};

const mutations = {
  setLogEntries:(state, logEntries) => (state.logEntries = logEntries),
  setLogTypes:(state, logTypes) => (state.logTypes = logTypes)
};

export default {
    state,
    getters,
    actions,
    mutations
}
